import { render, staticRenderFns } from "./listGroup.vue?vue&type=template&id=50dd494a&"
import script from "./listGroup.vue?vue&type=script&lang=js&"
export * from "./listGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports